import React from 'react';
import { Helmet } from 'react-helmet-async';
import ServiceSidebar from './ServiceSidebar';
import './Service.css';

const Pediatrics = () => {
  return (
    <div className="service-page">

      {/* ✅ SEO START */}
      <Helmet>
        <title>Pediatrician in Ambala | Child Specialist & Newborn Care | Amaanat IVF</title>

        <meta
          name="description"
          content="Expert pediatric care in Ambala at Amaanat IVF. Newborn care, vaccination programs, and child development monitoring."
        />

        <link rel="canonical" href="https://amaanativf.com/services/pediatrics" />

        {/* ✅ Medical Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalClinic",
            "name": "Amaanat IVF",
            "medicalSpecialty": "Pediatrics",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Ambala",
              "addressCountry": "India"
            }
          })}
        </script>

        {/* ✅ FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What services does a pediatrician provide?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Pediatricians provide care for newborns, vaccinations, growth monitoring, and treatment of childhood illnesses."
                }
              },
              {
                "@type": "Question",
                "name": "When should I take my child to a pediatrician?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "You should visit regularly for vaccinations, growth checks, or whenever your child is unwell."
                }
              },
              {
                "@type": "Question",
                "name": "Do you provide newborn care?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes, we provide complete newborn care including feeding guidance, health monitoring, and vaccination schedules."
                }
              }
            ]
          })}
        </script>
      </Helmet>
      {/* ✅ SEO END */}

      {/* HERO */}
      <section className="service-hero">
        <div className="container">

          <h1>Pediatrician in Ambala</h1>

          <p>
            Comprehensive care for newborns, infants & children
          </p>

          <div className="hero-stats">
            <span>Expert</span> Child Care
          </div>

        </div>
      </section>

      {/* MAIN */}
      <div className="services-layout container">

        <ServiceSidebar />

        <div className="services-content">

          <section>
            <h2>Child Care & Pediatric Services in Ambala</h2>
            <ul>
              <li>Newborn care and monitoring</li>
              <li>Vaccination programs</li>
              <li>Growth & development tracking</li>
              <li>Child health checkups</li>
            </ul>
          </section>

          {/* ✅ Hidden SEO Block */}
          <section style={{ marginTop: "40px" }}>
            <h2>Best Pediatrician in Ambala</h2>
            <p>
              Amaanat IVF provides expert pediatric care in Ambala for newborns and children.
              Our experienced doctors ensure proper growth, timely vaccinations, and complete
              child health monitoring in a safe and caring environment.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default Pediatrics;